"use client";

import styled from "styled-components";
import Image from "../image";

export const CardService = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--background);
  transition: all 0.3s ease;
  position: relative;
  height: 100%;
  width: 100%;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    padding: 15px;
    gap: 15px;
  }

  &:hover {
    box-shadow:
      0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
    transform: translateY(-2px);
    border-color: var(--primarySystem100);
  }
`;

export const BoxBody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-direction: column;
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  gap: 12px;
  padding-top: 5px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 12px;
`;

export const ImageEmployee = styled(Image)`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  object-fit: cover;
  border: 2px solid var(--border);
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
  }
`;

export const BoxIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  background: var(--grayCard);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 2px solid var(--border);

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  svg {
    width: 24px;
    height: 24px;
    stroke: var(--textLight);
  }
`;

export const InfoHeader = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: calc(100% - 76px);
`;

export const TitleCard = styled.h3`
  font-family: "Inter SemiBold";
  font-size: 18px;
  color: var(--colorTitle);
  display: block;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin-bottom: 6px;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const BoxAlign = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
  margin-bottom: 16px;
`;

export const Control = styled.div`
  display: flex;
  flex-direction: column;
  background: var(--grayCard);
  border-radius: 8px;
  padding: 12px;
  border: 1px solid var(--border);
  transition: all 0.2s ease;

  &:hover {
    background: var(--background);
    border-color: var(--primarySystem100);
  }
`;

export const TitleControl = styled.h4`
  font-family: "Inter Regular";
  font-size: 12px;
  color: var(--textLight);
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const Value = styled.span`
  font-family: "Inter SemiBold";
  font-size: 18px;
  color: var(--titleColor);
  line-height: 1.2;
`;

export const BodyCard = styled.div`
  width: 100%;
  text-align: left;
  margin-bottom: 12px;
`;

export const TextDescription = styled.p`
  font-family: "Inter Regular";
  color: var(--textLight);
  font-size: 13px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const FooterCard = styled.div`
  border-top: 1px solid var(--border);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  gap: 8px;
  padding-top: 16px;
  margin-top: auto;
`;

export const LastBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: nowrap;
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
`;

export const ListItemPlans = styled.ul`
  padding: 0;
  margin: 0;
  margin-top: 8px;
`;

export const ItemPlans = styled.li`
  display: block;
  font-family: "Inter Medium";
  font-size: 14px;
  color: var(--textLight);
  position: relative;
  padding-left: 10px;

  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 8px;
    width: 5px;
    height: 5px;
    border-radius: 50px;
    background: var(--primarySystem100);
  }
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;
`;
